// import getOneDaySchedules from './utils/getOneDaySchedules';
import blockFutureDays from './blockFutureDays';
import blockFutureUnpostedDays from './blockFutureUnpostedDays';
import blockUnpostedDays from './blockUnpostedDays'
import spanIncludesFutureDays from './utils/spanIncludesFutureDays';


/**
 * [scheduleView] Security Screening for Live Schedules
 * value = 2 ==> only items up to (and including) current day w/ 1-day postings, no future items ==> *[blockUnpostedDays] + [blockFutureDays]*
 * value = 3 ==> all items but only days w/ 1-day postings (past & future) ==> *[blockUnpostedDays]*
 * value = 4 ==> all items up to (and including) current day ==> *[blockFutureDays]*
 * value = 5 ==> all items up to (and including) current day + only future day types and day off requests ==> do nothing (SP does all the work)
 * value = 6 ==> everything ==> do nothing
 */

const securityFilter = ({ scheduleView, scheduleFormat, startDate, groups, items }) => {
  let updatedItems = [];

  if (scheduleView === 2) {
    updatedItems = blockFutureDays(startDate, groups, items, scheduleFormat);
    updatedItems = blockUnpostedDays(startDate, groups, updatedItems, scheduleFormat);
    return updatedItems;
  }
  if (scheduleView === 3) {
    updatedItems = blockUnpostedDays(startDate, groups, items, scheduleFormat);
    return updatedItems;
  }
  if (scheduleView === 4 && spanIncludesFutureDays(startDate, scheduleFormat)) {
    updatedItems = blockFutureDays(startDate, groups, items, scheduleFormat);
    return updatedItems;
  } else {
    return items;
  }
}

export default securityFilter;



// WEBPACK FOOTER //
// ./src/Components/Schedule/SevenNineDay/utils/live-schedule-view-security-filter/index.js